(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pd-media-text"] && !Shopify.designMode) return;
  try {
    
  if (!window._pdMediaTextObserver) {
    window._pdMediaTextObserver = true;
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        var video = entry.target;
        if (entry.isIntersecting) {
          video.play().catch(function() {});
        } else {
          video.pause();
        }
      });
    }, { rootMargin: '200px' });

    document.querySelectorAll('.pd-media-text .pd-lazy-video').forEach(function(video) {
      observer.observe(video);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pd-steps"] && !Shopify.designMode) return;
  try {
    
  if (!window._pdStepsObserver) {
    window._pdStepsObserver = true;
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        var video = entry.target;
        if (entry.isIntersecting) {
          video.play().catch(function() {});
        } else {
          video.pause();
        }
      });
    }, { rootMargin: '200px' });

    document.querySelectorAll('.pd-steps .pd-lazy-video').forEach(function(video) {
      observer.observe(video);
    });
  }

  } catch(e) { console.error(e); }
})();
})();
